import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HighchartsChartModule} from "highcharts-angular";
import {
  DxBoxModule, DxButtonModule, DxListModule, DxPopupModule, DxRadioGroupModule, DxResponsiveBoxModule, DxTabPanelModule,
  DxTreeListModule, DxTabsModule, DxLoadPanelModule, DxTextBoxModule, DxValidatorModule, DxValidationSummaryModule, DxDataGridModule, DxTemplateModule, DxBulletModule, DxScrollViewModule, DxLoadIndicatorModule, DxToolbarModule, DxSelectBoxModule
} from "devextreme-angular";
import {DxoPagingModule} from "devextreme-angular/ui/nested/paging";
import {DeviceDetectorModule} from "ngx-device-detector";
import { ReportComponent } from './report.component';
import { DxoPagerModule } from 'devextreme-angular/ui/nested/pager';
import { ReportService } from './report.service';
import { AuthComponent } from './auth/auth.component';
import { ChartsComponent } from './charts/charts.component';
import { DataViewComponent } from './data-view/data-view.component';
import { ProjectViewComponent } from './project-view/project-view.component';
import { PdfViewComponent } from './pdf-view/pdf-view.component';
import { ExternoChartsComponent } from './externo-charts/externo-charts.component';
import { PaginatorComponent } from '../../components/paginator/paginator.component';
@NgModule({
  imports: [
    CommonModule,
    DxTabPanelModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxBoxModule,
    DxPopupModule,
    DxTreeListModule,
    DxListModule,
    DxButtonModule,
    DxResponsiveBoxModule,
    HighchartsChartModule,
    DxRadioGroupModule,
    DeviceDetectorModule.forRoot(),
    DxoPagingModule,
    DxoPagerModule,
    DxTabsModule,
    DxLoadPanelModule,
    DxDataGridModule,
    DxTemplateModule,
    DxBulletModule,
    DxScrollViewModule,
    DxLoadIndicatorModule,
    DxToolbarModule,
    DxSelectBoxModule,
  ],
  declarations: [ReportComponent, AuthComponent, ChartsComponent, PdfViewComponent, DataViewComponent, ProjectViewComponent, ExternoChartsComponent, PaginatorComponent],
  providers: [ReportService],
  exports: [ReportComponent]
})
export class ReportModule { }



// WEBPACK FOOTER //
// ./src/app/pages/report/report.module.ts